export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/_worker.6822ecb4.worker.js");
}
